import { render } from "./Alarms.vue?vue&type=template&id=eff29b1a&ts=true"
import script from "./Alarms.vue?vue&type=script&lang=ts"
export * from "./Alarms.vue?vue&type=script&lang=ts"

import "./Alarms.vue?vue&type=style&index=0&id=eff29b1a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__